import { render, staticRenderFns } from "./EmailRegister.vue?vue&type=template&id=51f0e4b7&scoped=true&"
import script from "./EmailRegister.vue?vue&type=script&lang=js&"
export * from "./EmailRegister.vue?vue&type=script&lang=js&"
import style0 from "./EmailRegister.vue?vue&type=style&index=0&id=51f0e4b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f0e4b7",
  null
  
)

export default component.exports